import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import AlarmasSucursal from './AlarmasSucursal';
import Modal from 'react-bootstrap/Modal';
import ItemSucursal from './ItemSucursales';
import VerificarPermisos from '../Tools/VerificarPermisos';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function AdmiAlarmas() {
  const { loading, setLoading } = useContext(ContextGloball);
  const [regional, setRegional] = useState('990');
  const [sucursales, setSucursales] = useState([]);
  const [actualizar, setActualizar] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const getSucursales = (reg) => {
    setRegional(reg);
    fetch(`${server}/alarmas/getSucursales`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'regional': reg
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          console.log(data.ok);
          setSucursales(data.ok);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }
  function guardarInfo(info) {
    fetch(`${server}/alarmas/editarAlarma`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        info, regional
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          console.log(data.ok);
          setActualizar(!actualizar);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => console.log(err));
  }
  function guardarAccion(info) {
    setLoading(true);
    fetch(`${server}/alarmas/accionAlarma`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...info, regional
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          setActualizar(!actualizar);
          MsgUtils.msgCorrecto(data.ok);
        } else {
          MsgUtils.msgError(data.error);
        }
        setLoading(false);
      })
      .catch(err => MsgUtils.msgError(err));
  }
  useEffect(() => {
    getSucursales(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL);
  }, [actualizar])
  return (
    <>
      <div className='bg-dark bg-gradient text-start'>
        <div className='btn-group'>
          <button className='btn btn-sm btn-light' onClick={() => setActualizar(!actualizar)}><i className="fa-solid fa-rotate-right fa-2xl"></i></button>
          {VerificarPermisos.validarPermiso('35') && <button className='btn-success btn-sm btn' onClick={() => setShowModal(true)}>
            <i className="fa-solid fa-gear fa-2xl"></i>
          </button>}
        </div>
      </div>
      <div className='container-fluid py-2'>
        <div className='row row-cols-1 row-cols-sm-1 row-cols-md-4 g-2' >
          {sucursales.map((item, index) => {
            if (item.NUM_ALARMA != 0) {
              return (
                <div className='col' key={index}>
                  <div className="card bg-dark" >
                    <div className='card-header text-center text-light'>{item.SUCURSAL}</div>
                    <div className="card-body m-0 p-0">
                      <AlarmasSucursal alarmas={item.ALARMA} guardarAccion={guardarAccion} />
                    </div>
                  </div>
                </div>
              )
            }
          })}
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}
        backdrop="static"
        keyboard={false}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName='bg-dark bg-gradient'>
        <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
          <Modal.Title>
            <div className='text-light'>Configuraciones de Alarmas</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='table-responsive'>
            <table className="table table-dark">
              <thead>
                <tr>
                  <th scope="col">SUCURSAL</th>
                  <th scope="col">INCENDIO</th>
                  <th scope="col">LUZ</th>
                </tr>
              </thead>
              <tbody>
                {sucursales.map((item, index) => {
                  return (
                    <ItemSucursal sucursal={item} key={index} guardarInfo={guardarInfo} />
                  )
                })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AdmiAlarmas